























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import EventBus from '@/plugins/EventBus'

const defaultMessage: string = 'Todos os procedimentos indicados são autorizados apenas em regime de <strong>Hospital Dia</strong> para a operadora selecionada. Faremos as seguintes tratativas:'

@Component
export default class ComponentModalProcedimentosApenasHospitalDiaWarning extends Vue {
  @Prop({ required: true, default: defaultMessage }) message: string
  @Prop({ required: true, default: 'Medico' }) userType: string

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get showModalProcedimentosApenasHospitalDiaWarning() {
    return this.getSolicitacaoCirurgiaStore.modal.procedimentosApenasHospitalDiaWarning
  }

  set showModalProcedimentosApenasHospitalDiaWarning(value: boolean) {
    this.getSolicitacaoCirurgiaStore.setModal({ name: 'procedimentosApenasHospitalDiaWarning', value })
  }

  aceitarRecomendacao() {
    if (this.userType === 'Medico') {
      this.getSolicitacaoCirurgiaStore.adjustSolicitacaoTOHospitalDiaRules()
      EventBus.$emit('saveOrUpdateSecondStep')
      this.showModalProcedimentosApenasHospitalDiaWarning = false
      return
    }
    this.getBackofficeGlobalStore.adjustSolicitacaoTOHospitalDiaRules()
    EventBus.$emit('alterarSolicitacao')
    this.showModalProcedimentosApenasHospitalDiaWarning = false
  }

  toggleBodyOverflow() {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html) html.classList.toggle(noOverflowClass)
  }

  @Watch('showModalProcedimentosApenasHospitalDiaWarning')
  onChangeShowModalProcedimentosApenasHospitalDiaWarning(value: boolean) {
    this.toggleBodyOverflow()
  }
}
